import { runtimeConfig } from '../config';
import { CognitoAuth } from './cognito';
import { DevAuth } from './dev';
import type { AuthProvider } from './types';

let provider: AuthProvider | null = null;

export function auth(): AuthProvider {
  if (provider) return provider;
  const c = runtimeConfig();
  if (c.authMode === 'cognito') {
    if (!c.cognitoUserPoolId || !c.cognitoClientId) throw new Error('Configurazione Cognito mancante');
    provider = new CognitoAuth(c.cognitoUserPoolId, c.cognitoClientId);
  } else {
    provider = new DevAuth(c.devJwtSecret ?? 'solo-sviluppo-locale-non-usare-in-produzione');
  }
  return provider;
}

export function setAuthProviderForTests(p: AuthProvider): void {
  provider = p;
}

export * from './types';
